import { all, fork } from 'redux-saga/effects';
import { saga as envSaga } from 'wpt-duck-env';
import { saga as hashtagsSaga } from 'wpt-duck-hashtags';
import mainSaga from './mainSaga';

export default function* rootSaga() {
  yield all([fork(mainSaga), fork(hashtagsSaga), fork(envSaga)]);
}
